export default __webpack_public_path__ + "static/media/Prototype1.cf414390.png";